import { graphql } from 'relay-runtime';

// Query to list the library import tasks for the authenticated seller.
// Scope is applied server-side on the authenticated seller (no sellerID is passed).
// $state is optional: omitted (null) returns every task regardless of state.
export const libraryImportTasksQuery = graphql`
    query libraryImportTaskQueriesListQuery($state: Int) {
        libraryImportTasks(state: $state) {
            taskID
            target
            state
            stateName
            totalImages
            importedImages
            progressPercent
            errorCount
            lastError
            displayMessage
            createdOn
            startedOn
            modifiedOn
        }
    }
`;

// Mutation to manually restart a failed (state = Error) library import task.
// The restart is asynchronous and resumes from where it stopped (already-imported images are not re-uploaded).
// Triggers a manual import of the seller's default library gallery (legacy sellers who never got the automatic
// signup import). Idempotent server-side: returns the existing task if one is already present. Async — poll
// libraryImportTasks for progress afterwards.
export const importDefaultLibraryMutation = graphql`
    mutation libraryImportTaskQueriesImportDefaultMutation {
        importDefaultLibrary {
            taskID
            state
            stateName
            triggerType
            packageIDs
            totalImages
            importedImages
            progressPercent
            lastError
        }
    }
`;

export const restartLibraryImportTaskMutation = graphql`
    mutation libraryImportTaskQueriesRestartMutation($taskID: Long!) {
        restartLibraryImportTask(taskID: $taskID) {
            taskID
            state
            stateName
            progressPercent
            importedImages
            totalImages
            errorCount
        }
    }
`;
